export const HOME = '/';
export const OVERVIEW = '/overview';
export const CONSOLE = '/console';
export const CONSOLE_CONNECTION = CONSOLE + '/connection';
export const TERMINAL_LOGS = CONSOLE + '/terminal-logs';
export const SRM = '/srm';
export const CHANGE_REQUEST = '/change-request';

export const OIDC_TEST_CALLBACK = '/auth/oidc-test-callback';
export const OIDC_CALLBACK_ERROR = '/auth/oidc-callback-error';
export const LDAP_TEST_CALLBACK = '/auth/ldap-test-callback';

export const SETTINGS = '/settings';

export const DASHBOARDS = SETTINGS + '/dashboards';

export const ACCESS = SETTINGS + '/access-control';
export const ACCESS_SRM = ACCESS + '/srm';
export const ACCESS_HEALTH_INDICATOR = ACCESS + '/health-indicators';
export const ACCESS_NAVIGATION = ACCESS + '/navigation';
export const ACCESS_DASHBOARDS = ACCESS + '/dashboards';
export const ACCESS_DASHBOARDS_V4 = ACCESS_DASHBOARDS + '-acl';
export const ACCESS_TQL = ACCESS + '/tql';

export const USERS = SETTINGS + '/users';
export const USERS_REGISTRY = USERS + '/registry';
export const USERS_SESSIONS = USERS + '/sessions';
export const USERS_AUDIT_LOGS = USERS + '/audit-logs';

export const SETTINGS_SRM = SETTINGS + '/srm';
export const SETTINGS_CI_TYPES = SETTINGS_SRM + '/ci-types';
export const SETTINGS_ENRICHMENT = SETTINGS_SRM + '/enrichment';
export const SETTINGS_ENRICHMENT_LOGS = SETTINGS_SRM + '/enrichment-logs';
export const SETTINGS_CI_BULK_IMPORT = SETTINGS_SRM + '/ci-bulk-import';

export const SETTINGS_ATTRIBUTES = SETTINGS_SRM + '/attributes';

export const SETTINGS_MONITORING_PATH = SETTINGS + '/monitoring';
export const SETTINGS_MONITORING = SETTINGS_MONITORING_PATH + '/monitoring';
export const SETTINGS_MONITORING_TEMPLATES =
  SETTINGS_MONITORING_PATH + '/monitoring-templates';
export const SETTINGS_VM_AGENTS = SETTINGS_MONITORING_PATH + '/vm-agents';
export const SETTINGS_VM_ALERTS = SETTINGS_MONITORING_PATH + '/vm-alerts';
export const SETTINGS_S3 = SETTINGS_MONITORING_PATH + '/s3';
export const SETTINGS_MONITORING_EXPORTERS =
  SETTINGS_MONITORING_PATH + '/exporters';
export const SETTINGS_MONITORING_JOBS = SETTINGS_MONITORING_PATH + '/jobs';
export const SETTINGS_HEALTH_INDICATORS =
  SETTINGS_MONITORING_PATH + '/health-indicators';

export const SETTINGS_USER_ATTRIBUTES = USERS + '/attributes';
export const SETTINGS_LDAP = USERS + '/ldap';
export const SETTINGS_OIDC = USERS + '/oidc';

export const SETTINGS_SYSTEM = SETTINGS + '/system';
export const SETTINGS_GLOBAL = SETTINGS_SYSTEM + '/global';
export const SETTINGS_COMPONENTS = SETTINGS_SYSTEM + '/components';
export const SETTINGS_PLUGINS = SETTINGS_SYSTEM + '/plugins';
export const SETTINGS_CONTENT_PACK = SETTINGS_SYSTEM + '/content-pack';
export const SETTINGS_SCHEDULES = SETTINGS_SYSTEM + '/schedules';

export const SETTINGS_NOTIFICATIONS = SETTINGS + '/notifications';
export const SETTINGS_TIME_INTERVAL = SETTINGS_NOTIFICATIONS + '/time-interval';
export const SETTINGS_SENDERS = SETTINGS_NOTIFICATIONS + '/senders';
export const SETTINGS_ALERT_MANAGER = SETTINGS_NOTIFICATIONS + '/alert-manager';
export const SETTINGS_GENERAL = SETTINGS_NOTIFICATIONS + '/general';
export const SETTINGS_INHIBIT_RULES = SETTINGS_NOTIFICATIONS + '/inhibit-rules';
export const SETTINGS_NOTIFICATIONS_RECEIVERS =
  SETTINGS_NOTIFICATIONS + '/receivers';
export const SETTINGS_NOTIFICATIONS_SUBSCRIPTIONS =
  SETTINGS_NOTIFICATIONS + '/subscriptions';
export const SETTINGS_NOTIFICATIONS_TEMPLATES =
  SETTINGS_NOTIFICATIONS + '/templates';
export const SETTINGS_MY_RECEIVERS = SETTINGS_NOTIFICATIONS + '/my-receivers';

export const SETTINGS_LICENSE = SETTINGS + '/license';
export const PROFILE = '/profile';

export const NOTIFICATION = '/notification/:id';
export const NOTIFICATION_MANAGER = '/notification';

export const LOGIN = '/login';
export const CHANGE_PASSWORD = '/change-password';
export const MERGE_ACCOUNTS = '/auth/merge';

export const NO_ACCESS = '/no-access';

export const REDIRECT = '/redirect/:redirect-type';
